const QuotesComponent = () => {
    return (
        <div>
            <h1>Quotes</h1>
        </div>
    );
};

export default QuotesComponent;
